import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MaterialDetailDto } from '@models/material-detail-dto.interface';
import { MaterialsService } from '../../../../services/materials.service';
import { MaterialDetailComponent } from '../material-detail/material-detail.component';
import { EditMaterialDialogComponent } from '../edit-material-dialog/edit-material-dialog.component';

interface MaterialDetailDialogData {
  materialId: number;
  jobRequestId?: number;
}

@Component({
  selector: 'app-material-detail-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatProgressSpinnerModule, MaterialDetailComponent],
  templateUrl: './material-detail-dialog.component.html',
  styleUrl: './material-detail-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialDetailDialogComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<MaterialDetailDialogComponent>);
  private readonly data = inject<MaterialDetailDialogData>(MAT_DIALOG_DATA);
  private readonly materialsService = inject(MaterialsService);
  private readonly dialog = inject(MatDialog);

  protected material = signal<MaterialDetailDto | null>(null);
  protected isLoading = signal(true);

  ngOnInit(): void {
    this.materialsService.getMaterial(this.data.materialId).subscribe({
      next: detail => {
        this.material.set(detail);
        this.isLoading.set(false);
      },
      error: () => this.isLoading.set(false),
    });
  }

  protected onEditClick(materialId: number): void {
    this.dialogRef.close();
    this.dialog.open(EditMaterialDialogComponent, {
      width: '750px',
      minWidth: '750px',
      maxHeight: '90vh',
      data: { materialId, jobRequestId: this.data.jobRequestId },
    }).afterClosed().subscribe((updatedId: number | undefined) => {
      if (updatedId) {
        this.dialogRef.close(updatedId);
      }
    });
  }

  protected onClose(): void {
    this.dialogRef.close();
  }
}
